<header
    class="flex items-center justify-between h-16 px-6 lg:px-8 bg-white flex-shrink-0 ring-0 hover:ring-2 hover:ring-[#F4A261] hover:shadow-[0_0_20px_-4px_rgba(244,162,97,0.35)] transition-all duration-300 ease-out"
    style="border-radius: 30px; margin: 8px 8px 0 8px">
    <!-- Left: Logo + Collapse toggle aligned with sidebar -->
    <div class="flex items-center justify-between" style="width: 220px">
        <a class="flex items-center gap-2" routerLink="/dashboard">
            <img alt="SISPE" class="h-auto w-28" height="67" ngSrc="assets/images/dgpe/image4.svg" priority width="189" />
        </a>

        <!-- Collapse toggle - aligned with sidebar right edge -->
        <button
            aria-label="Basculer la barre latérale"
            class="w-8 h-8 flex items-center justify-center rounded-full border border-gray-200 text-gray-400 hover:text-gray-700 hover:border-gray-300 transition-colors"
            type="button"
            (click)="toggleSidebar.emit()">
            <svg
                aria-hidden="true"
                class="w-4 h-4 transition-transform duration-300"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                [class.rotate-180]="sidebarCollapsed()">
                <path d="M15 19l-7-7 7-7" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
            </svg>
        </button>
    </div>

    <!-- Center: date et heure. Masquées sous lg, comme le bloc nom/rôle, faute de place. -->
    <div class="hidden lg:flex flex-1 items-center justify-center gap-2 text-xs font-semibold text-gray-700">
        <svg aria-hidden="true" class="w-4 h-4 text-dgpe-primary-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2" />
        </svg>
        <time [attr.datetime]="maintenant().toISOString()">{{ maintenant() | date: 'EEE d MMM y' }}</time>
        <span aria-hidden="true" class="font-normal text-gray-300">·</span>
        <svg aria-hidden="true" class="w-4 h-4 text-dgpe-primary-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
        </svg>
        <span class="tabular-nums">{{ maintenant() | date: 'HH:mm:ss' }}</span>
    </div>

    <!-- Right: Bell + User profile -->
    <div class="flex items-center gap-3">
        <!-- Notification bell -->
        <button aria-label="Notifications" class="relative p-2 text-gray-500 hover:text-gray-700 transition-colors" type="button">
            <svg aria-hidden="true" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                    d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2" />
            </svg>
            <span aria-hidden="true" class="absolute top-1.5 right-1.5 w-2 h-2 bg-orange-400 rounded-full"></span>
        </button>

        <!-- User profile -->
        <div class="relative">
            <button
                aria-haspopup="menu"
                aria-label="Menu utilisateur"
                class="flex items-center gap-2.5 p-1.5 rounded-xl hover:bg-gray-50 transition-colors"
                type="button"
                [attr.aria-expanded]="menuOpen()"
                (click)="menuOpen.set(!menuOpen())">
                <!-- Avatar -->
                <div
                    class="w-9 h-9 rounded-full flex items-center justify-center text-white text-xs font-bold"
                    style="background: linear-gradient(135deg, #059669, #047857)">
                    {{ userInitials() }}
                </div>
                <!-- Name + role -->
                <div class="hidden lg:flex flex-col items-start leading-tight">
                    <span class="text-md font-semibold text-gray-800">{{ userDisplayName() }}</span>
                    <span class="text-xs text-gray-500">{{ userRole() }}</span>
                </div>
                <!-- Chevron -->
                <svg
                    aria-hidden="true"
                    class="hidden lg:block w-4 h-4 text-gray-400 transition-transform duration-200"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    [class.rotate-180]="menuOpen()">
                    <path d="M19 9l-7 7-7-7" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                </svg>
            </button>

            <!-- Dropdown -->
            @if (menuOpen()) {
                <div
                    aria-label="Menu utilisateur"
                    class="absolute right-0 mt-2 w-56 bg-white rounded-xl shadow-lg ring-1 ring-black/5 py-1 z-50 overflow-hidden"
                    role="menu">
                    <div class="px-4 py-3 border-b border-gray-100">
                        <p class="text-md font-medium text-gray-900">{{ userDisplayName() }}</p>
                        <p class="text-xs text-gray-500 truncate">{{ userEmail() }}</p>
                    </div>
                    <div class="py-1">
                        <a
                            class="flex items-center gap-3 px-4 py-2.5 text-md text-gray-700 hover:bg-gray-50 transition-colors"
                            role="menuitem"
                            routerLink="/profile"
                            (click)="menuOpen.set(false)">
                            <svg aria-hidden="true" class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path
                                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2" />
                            </svg>
                            Mon Profil
                        </a>
                        <!-- <a routerLink="/parametres" (click)="menuOpen.set(false)"
              class="flex items-center gap-3 px-4 py-2.5 text-md text-gray-700 hover:bg-gray-50 transition-colors">
              <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.066 2.573c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.573 1.066c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.066-2.573c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/></svg>
              Parametres
            </a> -->
                    </div>
                    <div class="border-t border-gray-100 py-1">
                        <button
                            class="flex items-center gap-3 w-full text-left px-4 py-2.5 text-md text-red-600 hover:bg-red-50 active:bg-red-100 transition-colors"
                            role="menuitem"
                            type="button"
                            (click)="onLogout()">
                            <svg aria-hidden="true" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path
                                    d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2" />
                            </svg>
                            Déconnexion
                        </button>
                    </div>
                </div>
            }
        </div>
    </div>
</header>
